import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  addCategory,
  getCategory,
} from "../../features/slices/categoryManagement";
import { toastService } from "../../utils/toastify";
import { imageUpload } from "../../features/slices/liveStream";
import LoaderForImage from "../LoaderForImage";
const CreateCategory = ({ setUpdateState }) => {
  const [formData, setFormData] = useState({
    categoryName: "",
    categoryType: "",
    image: "",
  });
  const [errors, setErrors] = useState({});
  const [imageLoader, setImageLoader] = useState(false);
  const dispatch = useDispatch();
  const { categoryType, categoryName, image } = formData;
  const closeModal = () => {
    setUpdateState((prev) => ({ ...prev, addCategoryModal: false }));
  };
  const handleChange = (e) => {
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;
    if (!categoryType?.trim()) {
      formErrors.categoryType = "Category type is required.";
      isValid = false;
    }
    if (!categoryName?.trim()) {
      formErrors.categoryName = "Category name is required.";
      isValid = false;
    }
    if (!image?.trim()) {
      formErrors.image = "image is required.";
      isValid = false;
    }
    setErrors(formErrors);
    return isValid;
  };
  const handleImage = (e) => {
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
    const file = e.target.files[0];
    setImageLoader(true);
    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);

      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Image uploaded successfully");
          setFormData((prev) => ({
            ...prev,
            [e.target.name]: res?.payload?.url,
          }));
          console.log({ formData, errors });

          setImageLoader(false);
        } else {
          toastService.error("Failed to upload");
          setImageLoader(false);
        }
      });
    }
  };
  const handleCreateCategory = (e) => {
       e.preventDefault();
    if (validateForm()) {
      dispatch(addCategory(formData)).then((res) => {
        if (res?.payload?.code == 200) {
          toastService.success("Category added successfully");
          dispatch(getCategory());
          closeModal();
        } else {
          toastService.error("Category added failed");
        }
      });
    }
  };
  return (
    <div className="ModalBox">
      <div
        id="NotificationAddModal"
        className="modal fade show"
        style={{ display: "block" }}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="Category">
                <a className="CloseModal" onClick={closeModal}>
                  ×
                </a>
                <h3>Create New Category</h3>
                <div className="form-group">
                  <label>Category Type</label>
                  {/* <select className="form-control">
                    <option>Select</option>
                    <option>Podcast</option>
                  </select> */}
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter category name"
                    name="categoryType"
                    value={categoryType}
                    onChange={handleChange}
                  />
                  {errors.categoryType && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.categoryType}
                    </p>
                  )}
                </div>
                <div className="form-group">
                  <label>Category Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter category name"
                    name="categoryName"
                    value={categoryName}
                    onChange={handleChange}
                  />
                  {errors.categoryName && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.categoryName}
                    </p>
                  )}
                </div>
                <div className="TitleBox Border">
                  <h4 className="Title">Category Image</h4>
                </div>
                <div className="form-group CommonForm ">
                  {imageLoader ? (
                    <LoaderForImage />
                  ) : (
                    <div
                      className="UploadBox Image"
                      style={{
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          zIndex: "99",
                        }}
                      >
                        {!image && <img src={image} />}
                        {image && (
                          <>
                            <img
                              src={image}
                              style={{
                                position: "absolute",
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                mixBlendMode: "darken",
                              }}
                            />
                            <i
                              className="fas fa-edit"
                              style={{
                                position: "absolute",
                                top: "5px",
                                right: "5px",
                                color: "#fff",
                                background: "rgba(0, 0, 0, 0.6)",
                                borderRadius: "50%",
                                padding: "5px",
                                zIndex: 2, // Place icon above the video
                                cursor: "pointer",
                              }}
                              // Trigger file input on icon click
                            />
                          </>
                        )}
                      </span>
                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg"
                        name="image"
                        onChange={handleImage}
                      />

                      <p>
                        <label>Click to upload</label> or <br /> drag &amp; drop
                      </p>
                    </div>
                  )}
                  {errors.image && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.image}
                    </p>
                  )}
                </div>
                <button className="Button" onClick={handleCreateCategory}>
                  Create New Category
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCategory;
